import Core from "../../errorCodes/Core"

/**
 * @todo: Handle all error codes in auth enum file
 */
export default function coreErrorHandler(errorCode: string) {
  switch (errorCode) {
    case Core.BusinessNotFound:
      return "errors.PBIDETenantNotFound"
    case Core.EmailAlreadyExists:
      return "errors.PBIDEEmailAlreadyExists"
    case Core.InvalidDOB:
      return "errors.PBIDEDOBInvalid"
    case Core.InvalidEmail:
      return "errors.PBIDEEmailInvalid"
    case Core.InvalidFirstName:
      return "errors.PBIDEFirstnameInvalid"
    case Core.InvalidGender:
      return "errors.PBIDEGenderInvalid"
    case Core.InvalidLastName:
      return "errors.PBIDELastnameInvalid"
    case Core.InvalidPhoneNumber:
      return "errors.PBIDEPhoneInvalid"
    case Core.InvalidProfileImage:
      return "errors.PBIDEProfileImageInvalid"
    case Core.InvalidSource:
      return "errors.PBIDESourceInvalid"
    case Core.InvalidSubdomain:
      return "errors.PBIDESubdomainInvalid"
    case Core.RoleNotFound:
      return "errors.PBIDERoleNotFound"
    case Core.SubdomainAlreadyExists:
      return "errors.PBIDESubdomainAlreadyExists"
    case Core.TeamNotFound:
      return "errors.PBIDETeamNotFound"
    case Core.UserNotFound:
      return "errors.PBIDEUserNotFound"
    case Core.Declined:
      return "errors.PBCOREDeclined"
    default:
      return ""
  }
}
